import { render } from "./BlockViewer.vue?vue&type=template&id=c3edc3d4&scoped=true"
import script from "./BlockViewer.vue?vue&type=script&lang=js"
export * from "./BlockViewer.vue?vue&type=script&lang=js"

import "./BlockViewer.vue?vue&type=style&index=0&id=c3edc3d4&scoped=true&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3edc3d4"],['__file',"src/BlockViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3edc3d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3edc3d4', __exports__)) {
    api.reload('c3edc3d4', __exports__)
  }
  
  module.hot.accept("./BlockViewer.vue?vue&type=template&id=c3edc3d4&scoped=true", () => {
    api.rerender('c3edc3d4', render)
  })

}


export default __exports__